<div class="charger-info-container">
  <!-- Header section with breadcrumb and metadata -->
  <div class="header-section">
    <!-- Breadcrumb -->
    <div class="breadcrumb">
      Dashboard › Chargers › <strong>CC02010031225001</strong>
    </div>

    <!-- Metadata info -->
    <div class="metadata-info">
      <div class="metadata-left">
        <div class="metadata-item">
          <span class="metadata-label">Charger Added on:</span>
          <span class="metadata-value">{{ charger.addedOn }}</span>
        </div></div>

      <div class="metadata-item">
        <span class="metadata-label">Last Action By:</span>
        <span class="metadata-value">{{ charger.lastActionBy }}</span>
      </div>
    </div>
  </div>

  <!-- Card -->
  <div class="info-card">
    <div class="card-header">
      <h3>CHARGER INFORMATION</h3>
      <mat-icon class="edit-icon">edit</mat-icon>
    </div>

    <div class="info-grid">
      <div class="info-item">
        <span class="label">Model</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.model }}</span>
      </div>

      <div class="info-item">
        <span class="label">Serial Number</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.serialNumber }}</span>
      </div>

      <div class="info-item">
        <span class="label">Address Line 1</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.address1 }}</span>
      </div>

      <div class="info-item">
        <span class="label">Address Line 2</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.address2 }}</span>
      </div>

      <div class="info-item">
        <span class="label">City</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.city }}</span>
      </div>

      <div class="info-item">
        <span class="label">State</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.state }}</span>
      </div>

      <div class="info-item">
        <span class="label">Zip Code</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.zip }}</span>
      </div>

      <div class="info-item">
        <span class="label">Country</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.country }}</span>
      </div>

      <div class="info-item">
        <span class="label">Latitude</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.latitude }}</span>
      </div>

      <div class="info-item">
        <span class="label">Longitude</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.longitude }}</span>
      </div>

      <div class="info-item">
        <span class="label">Charger Owner</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.owner }}</span>
      </div>

      <div class="info-item">
        <span class="label">Chosen Tariff Plan</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.tariff }}</span>
      </div>

      <div class="info-item">
        <span class="label">Price Per Kwh (₹)</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.price }}</span>
      </div>

      <div class="info-item">
        <span class="label">CGST (%)</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.cgst }}</span>
      </div>

      <div class="info-item">
        <span class="label">SGST (%)</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.sgst }}</span>
      </div>

      <div class="info-item">
        <span class="label">IGST (%)</span>
        <span class="colon">:</span>
        <span class="value">{{ charger.igst }}</span>
      </div>
    </div>
  </div>

  <div class="connector-card">

    <!-- Title -->
    <div class="card-title">
      <span class="heading">CONNECTOR INFORMATION</span>
    </div>

    <!-- Table Header -->
    <div class="table-header">
      <div>Plug</div>
      <div>Plug Status</div>
      <div>Plug Type</div>
    </div>

    <div class="table-row" *ngFor="let plug of plugs">
      <div class="plug-name">{{ plug.name }}</div>

      <div class="status">
        <span class="status-pill" [ngClass]="plug.status">
          {{ plug.status === 'in-use' ? 'In-Use' : 'Available' }}
        </span>
      </div>

      <div class="plug-type-actions">
        <span class="plug-type">{{ plug.type }}</span>
        <div class="actions">
          <mat-icon (click)="deletePlug(plug)">delete</mat-icon>
          <mat-icon (click)="editPlug(plug)">edit</mat-icon>
        </div>
      </div>
    </div>

  </div>

</div>
